var map = {
	"./svg/day/logo.svg": 833,
	"./svg/day/marker.svg": 1621,
	"./svg/day/marker_active.svg": 7668,
	"./svg/day/position.svg": 2840,
	"./svg/gps.svg": 8926,
	"./svg/headphones.svg": 1510,
	"./svg/night/logo.svg": 3116,
	"./svg/night/marker.svg": 7439,
	"./svg/night/marker_active.svg": 3024,
	"./svg/night/position.svg": 7264,
	"./svg/phone.svg": 9177,
	"./svg/texture.svg": 4781,
	"./svg/texture_blue.svg": 3750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2071;